<template>
  <div class="input-group border border-rounded" v-if="position == 'right'">
    <input
      :type="type"
      class="form-control border-0 outline-none shadow-none"
      :step="step"
      :placeholder="placeholder"
      :value="modelValue"
      :disabled="disabled"
      @input="handleInput($event)"
      @keypress="(filterFn || type === 'number') && (filterFn ? filterFn($event) : isNumber($event))"
      @keyup.delete="(filterFn || type === 'number') && (filterFn ? filterFn($event) : isNumber($event))"
      @paste="(filterFn || type === 'number') && (filterFn ? filterFn($event) : isNumber($event))"
      @blur="
        () => {
          onBlur && onBlur();
        }
      "
    />
    <span class="input-group-text bg-transparent border-0" id="basic-addon2">
      <slot></slot>
    </span>
  </div>
  <div class="input-group border border-rounded" v-else>
    <span class="input-group-text bg-transparent border-0" id="basic-addon2">
      <slot></slot>
    </span>
    <input
      :type="type"
      class="form-control border-0 outline-none shadow-none"
      :placeholder="placeholder"
      :value="modelValue"
      :disabled="disabled"
      @input="handleInput($event)"
      @keypress="(filterFn || type === 'number') && (filterFn ? filterFn($event) : isNumber($event))"
      @keyup.delete="(filterFn || type === 'number') && (filterFn ? filterFn($event) : isNumber($event))"
      @paste="(filterFn || type === 'number') && (filterFn ? filterFn($event) : isNumber($event))"
      @blur="
        () => {
          onBlur && onBlur();
        }
      "
    />
  </div>
  <div class="input-errors" v-for="(error, index) of errors" :key="index">
    <div class="text-danger mt-2 text-sm">
      {{ error.$message }}
    </div>
  </div>
</template>

<script>
import mixin from "@/mixin";
export default {
  mixins: [mixin],
  props: {
    type: {
      default: "text",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      required: true,
      type: String,
    },
    step: {
      type: String,
    },
    modelValue: {
      type: [String, Number],
    },
    filterFn: {
      type: Function,
    },
    onBlur: {
      type: Function,
    },
    errors: {
      type: Array,
    },
    position: {
      type: String,
      default: "right",
    },
    max: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    handleInput(event) {
      let value = event.target.value;
      
      // Limit decimal places to 2 digits
      if (value !== '') {
        // Replace comma with dot for consistent processing
        const normalizedValue = String(value).replace(',', '.');
        
        // Check if value has decimal point
        if (normalizedValue.includes('.')) {
          const parts = normalizedValue.split('.');
          // If more than 2 decimal places, truncate to 2
          if (parts[1] && parts[1].length > 2) {
            value = parts[0] + '.' + parts[1].substring(0, 2);
            // If original had comma, convert back
            if (String(event.target.value).includes(',')) {
              value = value.replace('.', ',');
            }
            event.target.value = value;
          }
        }
      }
      
      // If max is set, validate the input
      if (this.max !== null && this.max !== undefined && value !== '') {
        // Convert value to number (handle comma as decimal separator)
        const numericValue = parseFloat(String(value).replace(',', '.'));
        const maxValue = parseFloat(String(this.max).replace(',', '.'));
        
        // If the value exceeds max, prevent the input by reverting to previous value
        if (!isNaN(numericValue) && !isNaN(maxValue) && numericValue > maxValue) {
          // Revert to the previous value (modelValue)
          event.target.value = this.modelValue;
          return; // Don't emit the new value
        }
      }
      
      this.$emit('update:modelValue', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control {
  border: 1px solid #ced4da;
  padding: 10px 14px;
  font-size: 15px;
  color: #535353;
  background-color: #fff;
  border-radius: 100px !important;
  height: 43px;

  &::placeholder {
    color: #b4b4b4;
    text-align: left;
  }

  &:focus {
    outline: none;
    border: 1px solid #00697f;
  }

  &:disabled {
    opacity: 0.8;
    background-color: rgba(0, 0, 0, 0.05);
  }
  .btn {
    padding: 0.75rem !important;
    font-size: 15px !important;
  }
}
</style>
